import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SanitizationService {
  constructor(private sanitizer: DomSanitizer) {}

  sanitizeHtml(content: string): SafeHtml {
    if (!content) return '';

    // Remove script tags
    let cleanContent = content.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
    
    // Remove event handlers (onclick, onerror, etc.)
    cleanContent = cleanContent.replace(/on\w+="[^"]*"/gi, '');
    cleanContent = cleanContent.replace(/on\w+='[^']*'/gi, '');
    
    // Remove javascript: protocol
    cleanContent = cleanContent.replace(/javascript:/gi, '');
    
    // Remove data: URLs that could be dangerous
    cleanContent = cleanContent.replace(/data:text\/html/gi, '');
    
    // Sanitize using Angular's built-in sanitizer
    return this.sanitizer.sanitize(SecurityContext.HTML, cleanContent) as SafeHtml;
  }

  sanitizeUrl(url: string): string {
    if (!url) return '';
    
    // Remove javascript: protocol
    url = url.replace(/javascript:/gi, '');
    
    // Remove data: URLs
    url = url.replace(/data:/gi, '');
    
    return url;
  }

  sanitizeStyle(style: string): string {
    if (!style) return '';
    
    // Remove javascript: in styles
    style = style.replace(/javascript:/gi, '');
    
    // Remove expression() in styles (IE)
    style = style.replace(/expression\(/gi, '');
    
    return style;
  }
}

